import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted RTL font: no public CDN dependency for an internal console.
import '@fontsource-variable/vazirmatn';
import './styles/index.css';

import { App } from './App';
import { createProvider, readProviderConfig } from './api/provider';
import { applyRtlDocument } from './lib/rtl';
import { initTheme } from './lib/theme';

const config = readProviderConfig();
applyRtlDocument();
initTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing <div id="root">');
}

createRoot(container).render(
  <StrictMode>
    <App api={createProvider({ config })} base={config.routerBase} />
  </StrictMode>,
);
